<template>
  <div class="playlet">
    <el-card>
      <div style="margin-bottom:20px;display: flex;justify-content: space-between;">
        <div style="display: flex;">
          <el-input
            v-model="parameter.keyword"
            placeholder="请输入小程序名称 appid"
            style="width:230px;margin-right:10px"
          />
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="serawed"
          >搜索</el-button>
          <el-button
            type="info"
            icon="el-icon-refresh"
            @click="reset"
          >重置</el-button>
        </div>
        <el-button
          size="mini"
          type="success"
          icon="el-icon-s-help"
          @click="add"
        >创建</el-button>
      </div>

      <div>
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="applet_name"
            label="名称"
            width="300"
            align="center"
          />
          <el-table-column
            prop="created_at_text"
            label="创建时间"
            width="200"
            align="center"
          />
          <el-table-column
            prop="created_at_text"
            label="分类名称"
            width="850"
            align="center"
          >
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center;">
                <div
                  v-for="(item,index) in scope.row.category_info"
                  :key="index"
                >{{ item.name }},</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
          >
            <template scope="scope">
              <el-button
                type="warning"
                size="small"
                @click="edit(scope.row)"
              >编辑</el-button>
              <el-button
                type="danger"
                size="small"
                @click="myDelete(scope.row.app_id)"
              >删除</el-button>
            </template>
          </el-table-column></el-table>
      </div>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <el-dialog
      title="新增"
      :visible.sync="cookiedialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
      width="700px"
    >
      <classificationdialog
        ref="sourdialogview"
        @updata="updatar"
      />
    </el-dialog>
  </div>
</template>

<script>
import classificationdialog from './components/classificationdialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { videoCategoryRelationlist, videoCategoryRelationdelete } from '@/api/sourceminiprogram.js'
export default {
  name: 'Playlet',
  components: {
    PaginationRight,
    classificationdialog
  },
  data() {
    return {
      parameter: {
        page: 1,
        page_size: 10,
        keyword: ''
      },
      loading: false,
      tableData: [],
      total: null,
      cookiedialogVisible: false
    }
  },

  created() {
    this.getDatas()
  },
  activated() {
    this.getDatas()
  },
  mounted() {},
  methods: {
    add() {
      this.cookiedialogVisible = true
      this.$nextTick(() => {
        this.$refs.sourdialogview.send(1)
      })
    },
    edit(item) {
      this.cookiedialogVisible = true
      this.$nextTick(() => {
        this.$refs.sourdialogview.send(2, item)
      })
    },
    async getDatas() {
      this.loading = true
      const data = await videoCategoryRelationlist(this.parameter)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
    },
    fetchPageSize(e) {
      this.parameter.page_size = e
      this.getDatas()
    },

    fetchCurrentPage(e) {
      this.parameter.page = e
      this.getDatas()
    },

    // 删除
    myDelete(app_id) {
      console.log('app_id', app_id)
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          videoCategoryRelationdelete({
            app_id: app_id
          }).then(res => {
            this.getDatas()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    serawed() {
      this.parameter.page = 1
      this.getDatas()
    },
    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10,
        keyword: ''
      }
      this.getDatas()
    },

    updatar() {
      this.cookiedialogVisible = false
      this.getDatas()
    }
  }
}
</script>

<style scoped>
.playlet {
  margin: 30px;
  width: 95%;
  margin: 0 auto;
}
.el-card {
  margin-top: 20px;
}
.selectionArea {
  display: flex;
  flex-wrap: wrap;
}

.item {
  display: flex;
  align-items: center;
  flex-basis: calc(25% - 10px);
  margin-right: 10px;
  margin-bottom: 10px;
}

.title {
  white-space: pre;
  display: inline-block;
  margin-right: 7px;
}

.button-group {
  flex-basis: 100%; /* 按钮组占据一整行宽度 */
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.box-card {
  height: 70px;
}
</style>

